import { memo, ReactNode } from 'react';
import { IconEmpty } from '@app/icons';
import { cn } from 'lib/utils';

interface EmptyProps {
  title?: string | React.ReactNode;
  icon?: ReactNode;
  className?: string;
}

function Empty(props: EmptyProps) {
  const { title = '', icon, className } = props;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 py-8 px-4 rounded-lg bg-muted/20',
        className
      )}
    >
      {icon ?? <IconEmpty className="w-12 h-12 text-muted-foreground/40" />}
      <p className="text-base text-muted-foreground font-medium text-center">
        {title}
      </p>
    </div>
  );
}

export default memo(Empty);
